import { styled } from "@mui/material/styles";
import {
  ChangeEvent,
  useCallback,
  useContext,
  useEffect,
  useState,
} from "react";
import { UserContext } from "../../context";
import useServiceOrders from "../../hooks/service-orders";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import {
  Box,
  Button,
  Drawer,
  FormControl,
  Input,
  InputAdornment,
  InputLabel,
  Modal,
  Step,
  StepContent,
  StepLabel,
  Stepper,
  Tab,
  TextField,
  Typography,
} from "@mui/material";
import CollapsibleTable from "../../components/collapsible-table";
import { Timestamp } from "firebase/firestore";
import moment from "moment";
import usePrices from "../../hooks/prices";
import ROUTES from "../../eums/route";
import { Link } from "react-router-dom";
import Invoice from "../invoice";
import { SubmitHandler, useForm } from "react-hook-form";
import useInvoiceConfig from "../../hooks/invoice-config";

const ServiceOrders = () => {
  const userWorker = useContext(UserContext);

  const { get: getServiceOrders, edit } = useServiceOrders();
  const { get: getInvoiceConfig, edit: editInvoiceConfig } = useInvoiceConfig();

  const {
    register,
    handleSubmit,
    watch,
    setValue,
    reset,
    formState: { errors },
  } = useForm<ServiceOrder>();
  const { get: getPrices } = usePrices();
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const [openDrawer, setOpenDrawer] = useState(false);

  const [invoiceService, setInvoiceService] = useState<ServiceOrder>();
  const [waitingFor, setWaitingFor] = useState<ServiceOrder[]>();
  const [onTheWay, setOnTheWay] = useState<ServiceOrder[]>();
  const [inProgress, setInProgress] = useState<ServiceOrder[]>();
  const [completed, setCompleted] = useState<ServiceOrder[]>();
  const [price, setPrice] = useState<
    Prices & {
      id: string;
    }
  >();
  const toggleDrawer = ({ data }: { data?: ServiceOrder }) => {
    reset(data);
    setOpenDrawer(!openDrawer);
  };
  useEffect(() => {
    if (userWorker.user?.companyId)
      getPrices(userWorker.user?.companyId).then((resp) => {
        if (resp) setPrice(resp[0]);
      });
  }, [userWorker.user?.companyId]);
  const format = (date: Timestamp) => {
    const { seconds, nanoseconds } = date;
    const auxi = moment
      .unix(seconds)
      .add(nanoseconds / 1000000, "milliseconds");
    const format1 = "HH:mm:ss DD/MM/YYYY ";
    return moment(auxi).format(format1);
  };
  const getOrders = useCallback(() => {
    const fn = async () => {
      const resp = await getServiceOrders();
      console.log(resp);
      setWaitingFor(resp.filter((item) => item.statusList.length === 1));
      setOnTheWay(resp.filter((item) => item.statusList.length === 2));
      setInProgress(
        resp.filter(
          (item) =>
            item.statusList.length > 2 &&
            item.statusList.filter(({ status }) => status === "invoiceSent")
              .length === 0
        )
      );
      setCompleted(
        resp.filter(
          (item) =>
            item.statusList.filter(({ status }) => status === "invoiceSent")
              .length > 0
        )
      );
    };
    fn();
  }, []);

  const onSubmit: SubmitHandler<ServiceOrder> = async (data) => {
    console.log(data);
    const id = watch("id");
    console.log(id);

    let newData = { ...data };
    if (!data.invoiceNumber) {
      const resp = await getInvoiceConfig();
      newData.invoiceNumber = resp[0].nextId;
      editInvoiceConfig("config", { nextId: resp[0].nextId + 1 });
    }
    await edit(id, newData);
    getOrders();
    toggleDrawer({});

    setInvoiceService(newData);
    handleOpen();
  };
  useEffect(() => {
    getOrders();
  }, [getOrders]);
  const [valueTab, setValueTab] = useState("1");

  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    setValueTab(newValue);
  };

  const handleChangeInput = (
    id: keyof ServiceOrder,
    event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    let newValue = event.target.value.replace(/\D/g, ""); // Remove tudo que não for número

    // Remove zeros à esquerda, mas mantém pelo menos um zero se o valor for muito pequeno
    newValue = newValue.replace(/^0+(\d)/, "$1");

    // Se for vazio, define "0"
    if (newValue === "") {
      newValue = "0";
    }

    // Se tiver menos de 3 dígitos, adiciona zeros à esquerda
    while (newValue.length < 3) {
      newValue = "0" + newValue;
    }

    // Insere o ponto antes dos últimos 2 dígitos
    newValue = newValue.slice(0, -2) + "." + newValue.slice(-2);

    setValue(id, newValue, { shouldValidate: true });
  };

  const travelCost = watch("totalRide", "0");
  const workCost = watch("totalTime", "0");
  const materialCost = watch("totalMaterials", "0");
  useEffect(() => {
    let sum = 0;

    if (travelCost) sum += parseFloat(travelCost);
    if (workCost) sum += parseFloat(workCost);
    if (materialCost) sum += parseFloat(materialCost);

    setValue("totalPrice", sum.toFixed(2) + "");
  }, [travelCost, workCost, materialCost]);
  const RenderTable = ({
    data,
    showActions = false,
  }: {
    data?: ServiceOrder[];
    showActions?: boolean;
  }) => (
    <div className="w-full">
      <CollapsibleTable
        header={[
          "",
          "Create at",
          "Client",
          "Phone",
          "Travel Cost",
          "Work hours cost",
          "Material cost",
          "Total price",
          "Sales Order No",
          "",
        ]}
        rows={
          data?.map((service: ServiceOrder) => {
            //const prices = calculateCost(service);
            return {
              cells: [
                (service.createdAt as Timestamp).toDate().toDateString(),
                service.clientName,
                service.contactPhone,
                Number(service.totalRide || 0).toFixed(2) + "£",
                Number(service.totalTime || 0).toFixed(2) + "£",
                Number(service.totalMaterials || 0).toFixed(2) + "£",
                Number(service.totalPrice || 0).toFixed(2) + "£",
                service.invoiceNumber
                  ? Number(service.invoiceNumber) + ""
                  : "Invoice not generated",
                showActions ? (
                  <Button
                    onClick={() => {
                      toggleDrawer({ data: service });
                    }}
                    variant="contained"
                    color="secondary"
                  >
                    {service.invoiceNumber ? "Invoice" : "Generat Invoice"}
                  </Button>
                ) : (
                  ""
                ),
              ],
              component: () => (
                <Stepper
                  activeStep={service.statusList.length - 1}
                  alternativeLabel
                >
                  {service.statusList.map((status) => (
                    <Step>
                      <StepLabel>
                        {status.status}
                        <Typography>
                          {format(status.time as Timestamp)}
                        </Typography>
                      </StepLabel>
                    </Step>
                  ))}
                </Stepper>
              ),
            };
          }) || []
        }
      />
    </div>
  );
  return (
    <Box
      sx={{
        minWidth: "500px",
        minHeight: "3ls00px",
        display: "flex",
        flexDirection: "column",
        gap: "16px",
        paddingTop: "64px",
      }}
    >
      <TabContext value={valueTab}>
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <TabList onChange={handleChange} aria-label="lab API tabs example">
            <Tab
              label={"Waiting for worker (" + waitingFor?.length + ")"}
              value="1"
            />
            <Tab label={"On the way (" + onTheWay?.length + ")"} value="2" />
            <Tab label={"In progress(" + inProgress?.length + ")"} value="3" />
            <Tab label={"Completed(" + completed?.length + ")"} value="4" />
          </TabList>
        </Box>
        <TabPanel value="1">
          <RenderTable data={waitingFor} />
        </TabPanel>
        <TabPanel value="2">
          <RenderTable data={onTheWay} />
        </TabPanel>
        <TabPanel value="3">
          <RenderTable data={inProgress} />
        </TabPanel>
        <TabPanel value="4">
          <RenderTable data={completed} showActions />
        </TabPanel>
      </TabContext>

      <Drawer anchor={"right"} open={openDrawer} onClose={toggleDrawer}>
        <div className="p-[24px] pt-[88px]">
          Edit invoice
          <form
            onSubmit={handleSubmit(onSubmit)}
            className="flex flex-col gap-[24px]"
          >
            {(
              [
                { label: "Travel cost", id: "totalRide" },
                { label: "Work hours cost", id: "totalTime" },
                { label: "Material cost", id: "totalMaterials" },
              ] as {
                label: string;
                id: keyof ServiceOrder;
              }[]
            ).map(({ label, id }) => (
              <FormControl fullWidth sx={{ m: 1 }} variant="standard">
                <InputLabel htmlFor="standard-adornment-amount">
                  {label}
                </InputLabel>
                <Input
                  id="outlined-basic"
                  {...register(id, { required: true })}
                  inputProps={{
                    inputMode: "decimal", // Para dispositivos móveis
                    pattern: "[0-9]*[.,]?[0-9]{0,2}",
                  }}
                  onChange={(e) => handleChangeInput(id, e)}
                  startAdornment={
                    <InputAdornment position="start">£</InputAdornment>
                  }
                />
              </FormControl>
            ))}

            <FormControl fullWidth sx={{ m: 1 }} variant="standard">
              <InputLabel htmlFor="standard-adornment-amount">
                Total price
              </InputLabel>
              <Input
                disabled
                id="outlined-basic"
                {...register("totalPrice", { required: true })}
                startAdornment={
                  <InputAdornment position="start">£</InputAdornment>
                }
              />
            </FormControl>

            <Button type="submit" variant="contained" color="secondary">
              Save
            </Button>
          </form>
        </div>
      </Drawer>
      <Modal
        keepMounted
        open={open}
        onClose={handleClose}
        aria-labelledby="keep-mounted-modal-title"
        aria-describedby="keep-mounted-modal-description"
      >
        <div className="overflow-scroll h-vh mx-auto w-[794px]">
          <Invoice service={invoiceService} close={handleClose} />
        </div>
      </Modal>
    </Box>
  );
};

export default ServiceOrders;
